export default "__VITE_ASSET__CPUoI5vk__"